import { getListNotification } from './api';
export const fetchGetListNotification = async (params: SearchParamsNotification): Promise<IBaseAPISearchRes<INotificationList>> => {
  try {
      const response = await getListNotification(params);
      return response.data;
  } catch (error: any) {
      console.log(error);
      return error;
  }
};